import { requestHttp } from "../utils/HttpRequest";

export const getSellerSalesTrackerMetrics = (idUser, date,idr) => {
  try {
    const response = requestHttp({
      endpoint: "seller_sales_tracker_metrics",
      data: {
        user_id: idUser,
        chosen_date: date,
        idr:idr,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
